// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamSeasonStatsGetBody = {
  teamId: string;
};

export type typeTeamSeasonStatsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    leagueId: string;
    leagueSeasonId?: string | null;
    seasonLabel?: string | null;
    hasStats: boolean;
    sections: {
      sectionKey: string;
      label: string;
      rows: {
        rowKey: string;
        label: string;
        displayValue: string;
        rankLabel?: string | null;
        rankedTeamCount: number;
      }[];
    }[];
  };
};

export type typeTeamSeasonStatsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamSeasonStatsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamSeasonStatsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamSeasonStatsGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamSeasonStatsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamSeasonStatsGetBody);
  }

  return async function postTeamSeasonStatsGet(
    payload: typeTeamSeasonStatsGetBody,
  ): Promise<
    typeTeamSeasonStatsGetOutput200 | typeTeamSeasonStatsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamSeasonStatsGet" failed before calling the network. #58266681c9aa`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#58266681c9aa" },
        },
        data: null,
      } as typeTeamSeasonStatsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/season-stats-get`,
      httpMethod: "POST",
      options,
    })) as typeTeamSeasonStatsGetOutput200 | typeTeamSeasonStatsGetOutput400;
  };
}
